import { render, staticRenderFns } from "./DictSelect.vue?vue&type=template&id=78f0a552&scoped=true"
import script from "./DictSelect.vue?vue&type=script&lang=js"
export * from "./DictSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f0a552",
  null
  
)

export default component.exports